"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SystemPageSubTypes = _interopRequireDefault(require("../constants/SystemPageSubTypes"));

var _default = {
  ALL: 'all-products',
  NONE: 'NONE',
  EMAIL_TEMPLATES: 'EMAIL',
  LANDING_PAGES: 'LANDING_PAGE',
  SITE_PAGES: 'SITE_PAGE',
  BLOG_TEMPLATES: 'BLOG',
  PACKS: 'COS_TEMPLATE_PACK',
  UNSUBSCRIBE_SIMPLE: _SystemPageSubTypes.default.UNSUBSCRIBE_SIMPLE,
  ERROR_PAGE: _SystemPageSubTypes.default.ERROR_PAGE,
  PASSWORD_PAGE: _SystemPageSubTypes.default.PASSWORD_PAGE,
  SUBSCRIPTION_PREFERENCES: _SystemPageSubTypes.default.SUBSCRIPTION_PREFERENCES,
  UNSUBSCRIBE_CONFIRMATION: _SystemPageSubTypes.default.UNSUBSCRIBE_CONFIRMATION,
  CONTENT_SEARCH_RESULTS: _SystemPageSubTypes.default.CONTENT_SEARCH_RESULTS,
  CUSTOM_MODULE: 'CUSTOM_MODULE'
};
exports.default = _default;
module.exports = exports.default;